import { FC, SyntheticEvent, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { EPermissionGroup } from 'common/permissions.types';
import { EPermissionAction } from 'common/permissions.types';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';
import { ERouteContext } from 'routes/types';
import { permissionsUtil } from 'utils/permissionsUtil';

import PageTopBar from 'components/Topbar/PageTopBar';
export enum EPricingFormState {
  PRICING_POINTS = 'points',
  SETTINGS = 'settings'
}

export const PricingView: FC<{ context: ERouteContext }> = ({ context }) => {
  const navigate = useNavigate();
  const { publisherId } = useParams();
  const location = useLocation();
  const currentTab = location.pathname.split('/')[4];
  const [tab, setTab] = useState(currentTab);

  const handleTabChange = (
    event: SyntheticEvent,
    newValue: EPricingFormState
  ) => {
    setTab(newValue);
    const newPath = `/${context === ERouteContext.PORTAL_LEVEL_STORE ? 'store' : 'project'}/${publisherId}/pricing/${newValue}`;
    navigate(newPath);
  };

  const isPricingManage = permissionsUtil.isActionEnabled(
    null,
    EPermissionGroup.PRICING,
    EPermissionAction.MANAGE
  );

  const tabs = [
    { label: 'Price Points', value: EPricingFormState.PRICING_POINTS }
  ];

  if (isPricingManage) {
    tabs.push({ label: 'Settings', value: EPricingFormState.SETTINGS });
  }

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={
        <PageTopBar withTabsDesign={true} disable={false} headline="Pricing" />
      }
      handleTabChange={handleTabChange}
      activeTabVal={tab}
    />
  );
};
